/**
 * Created by tomers on 2/23/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var categories = require("manager-assets/data/data-sources/integrations/categories.json");
    var IntegrationsCategoriesCollection = require("manager-collections/data-sources/integrations/IntegrationsCategoriesCollection");
    var IntegrationsCategoriesView = require("manager-views/data-sources/integrations/IntegrationsCategoriesView");

    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var DataSourcesAnalyticsController = require("manager-controllers/DataSourcesAnalyticsController");
    var DataSourcesLpTagController = require("manager-controllers/DataSourcesLpTagController");
    var MetricsDataSourcesController = require("manager-controllers/MetricsDataSourcesController");
    var IntegrationsRowModel = require("manager-models/data-sources/integrations/IntegrationsRowModel");

    var CONNECTORS = "Connectors";
    var LE_GENERAL_MONITORING = "LE_General_Monitoring";

    var IntegrationsListController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        IntegrationsListController = Marionette.Controller.extend({
            categoriesView: null,

            initialize: function(options) {
                this._initialize(options);
            },

            getView: function() {
                return this._getView();
            },

            _initialize: function(options) {
                this.channel = LEManager.media.channel("dataSources");
                this.vent = this.channel.vent;
                this.dataSourcesLpTagController = new DataSourcesLpTagController();
                this.dataSourcesAnalyticsController = new DataSourcesAnalyticsController();
                this._bindEvents();

            },
            _bindEvents: function() {
                /* bind to Google Analytics API related events */
                this.dataSourcesAnalyticsController.bindToGoogleAnaliticsEvents();

                /* fired when the connect button is clicked */
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.root.TRIGGERING.ACTION_BUTTON_CLICKED, _.bind(this._handleActionButtonClick, this));

                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.root.TRIGGERING.SYNC_CONNECTORS_CONNECTIONS, _.bind(this._syncConnectorsConnections, this));

            },

            _getView: function() {
                this._initData();
                this._initViews();
                return this.categoriesView;
            },

            _initData: function() {
                if(LE.siteSettings.customizationSettings.isHideLeTagPage()) {
                    this._removeMonitoring();
                }
                this.categoriesCollection = new IntegrationsCategoriesCollection(categories);

                /* get the Connectors connection GA and Lptag status asynchronously */
                this.dataSourcesAnalyticsController.isConnectedToGoogle();
                if(!LE.siteSettings.customizationSettings.isHideLeTagPage()) {
                    this.dataSourcesLpTagController.isConnectedToLpTag();
                }

                //get all the SDES metric count
                this._getCountData();

                if (!LE.sessionManager.hasAuthenticationChatFeature()){
                    var authModel = this.categoriesCollection.getAuthenticationServerRow();
                    authModel.setShow(false);
                }

                if (!LE.siteSettings.accountSettings.isAutomotive()) {
                    var automotiveModel = this.categoriesCollection.getAutomotiveRow();
                    automotiveModel.setShow(false);
                }
            },

            _removeMonitoring: function() {
                _.some(categories, function(category) {
                    if(category.name === CONNECTORS) {
                        category.rows = _.without(category.rows, _.find(category.rows, {name: LE_GENERAL_MONITORING}));
                        return true;
                    }
                }, this);
            },

            _initViews: function() {
                this.categoriesView = new IntegrationsCategoriesView({collection:this.categoriesCollection});
            },

            _getCountData: function(){
                LEManager.logger.debug("IntegrationsListController:_getCountData - started");

                //get the metric event type
                var metricTypes = this.categoriesCollection.getAllMetricsParameterNames();

                MetricsDataSourcesController.getDataSourcesJsonMetrics({
                    types: metricTypes,
                    success: _.bind(this._onCountDataSuccess, this),
                    error: _.bind(this._onCountDataError, this)});
            },

            _onCountDataSuccess: function(data, options){
                LEManager.logger.debug("IntegrationsListController:_onCountDataSuccess - started");

                this._setConnectionsStatus({isSuccess: true, data: data});
            },

            _onCountDataError: function(error, options){
                LEManager.logger.error("IntegrationsListController:_onCountDataError - reporting metrics error - " + error);

                this._setConnectionsStatus({isSuccess: false});
            },

            _setConnectionsStatus: function(status){
                LEManager.logger.debug("IntegrationsListController:_setConnectionsStatus - started");

                if (status.isSuccess && status.data) {
                    var CountDataModel = status.data;
                    this.categoriesCollection.updateConnectionsFromMetrics(CountDataModel);
                }
                else {
                    LEManager.logger.error("IntegrationsListController:_setConnectionsStatus - could not get the metric count - status: " + status);
                }
            },

            _syncConnectorsConnections: function(conns, ConnectorsConfig){
                LEManager.logger.debug("IntegrationsListController:_syncConnectorsConnections - started");

                this.categoriesCollection.updateConnectionsFromConnectors(conns, ConnectorsConfig);
            },

            _handleActionButtonClick: function(model){
                LEManager.logger.debug("IntegrationsListController:_handleActionButtonClick - started");

                /* in case of Connectors data source (GA or LpTag) handdle the connect button accordingly */
                var actionType = model.getActionType();
                if (actionType === IntegrationsRowModel.ACTION_TYPE.CONNECT){
                    if (model.isGoogleAnalytics()){
                        this.dataSourcesAnalyticsController.doConnectToGoogle(model);
                    }
                    else if (model.isLiveEngageTag()){
                        this.dataSourcesLpTagController.doConnectToLptag(model);
                    }
                }
                else if (actionType === IntegrationsRowModel.ACTION_TYPE.ROUTE){
                    LEManager.router.navigate(model.getRouteButtonClick());
                }
                else if (actionType === IntegrationsRowModel.ACTION_TYPE.KP){
                    LE.vent.trigger(ManagerConfig.dataSources.mainConfig.KP.LEEventName, {fragment: model.getSlugId()});
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsListController;
});
